<template>
  <div class="modal-overflow" style="max-height: 600px;">
    <textarea id="taskName" style="width: 100%; height: 500px;">
      {{ taskNameJson }}
    </textarea>
  </div>
</template>

<script>
import {notifySuccess} from 'src/utilities/utils'

export default {
  props: ['data'],
  computed: {
    taskNameJson() {
      const nonReactiveCopy = JSON.parse(JSON.stringify(this.data))
      delete nonReactiveCopy.ownerId
      delete nonReactiveCopy.createdAt
      delete nonReactiveCopy.createdBy
      delete nonReactiveCopy.updatedAt
      delete nonReactiveCopy.updatedBy
      delete nonReactiveCopy.files
      delete nonReactiveCopy.entityType
      delete nonReactiveCopy.taskTemplateName
      delete nonReactiveCopy.departmentNames
      return JSON.stringify(nonReactiveCopy, undefined, 2)
    }
  },
  mounted() {
    const taskName = document.getElementById('taskName')
    taskName.select()
    taskName.setSelectionRange(0, 99999) // for mobile devices
    document.execCommand('copy')
    notifySuccess(this, this.data.name + ' has been copied to your clipboard')
  }
}
</script>
